import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";

export const ModalImprimirComprobantesIva = (props) => {
  const op = require("../../modulos/datos");
  const fechaActual = new Date().toISOString().split("T")[0];
  const anioActual = new Date().getFullYear();
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [fechas, setFechas] = useState({
    desde: `${anioActual}-01-01`,
    hasta: fechaActual,
  });
  // Adm_List_ComprobanteIVA
  const imprimirReporte = () => {
    try {
      const condicion = `fecharet between '${fechas.desde}'::date and '${fechas.hasta}'::date`;
      window.open(
        `${op.reportes}/actividadeconomica?reporte=Adm_List_ComprobanteIVA&CONDICION=${condicion}&efiscal=${idefiscal}&desde=${moment(fechas.desde).format("DD-MM-YYYY")}&hasta=${moment(fechas.hasta).format("DD-MM-YYYY")}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      console.log(error);
    }
  };
  const salir = () => {
    props.setTabla(0);
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.521)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          Listado de Comprobantes de IVA
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between col-md-12">
          <div className="col-md-4 row py-2 m-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Desde:
              </span>
              <input
                type="date"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                max={fechaActual}
                value={fechas.desde}
                onChange={(e) => {
                  const { value } = e.target;
                  setFechas((prev) => ({
                    ...prev,
                    desde: value,
                  }));
                }}
              />
            </div>
          </div>
          <div className="col-md-4 row py-2 m-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Hasta:
              </span>
              <input
                type="date"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                max={fechaActual}
                value={fechas.hasta}
                onChange={(e) => {
                  const { value } = e.target;
                  setFechas((prev) => ({
                    ...prev,
                    hasta: value,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-info col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
    </Modal>
  );
};
